import { render } from "./WxCard.vue?vue&type=template&id=519f51fa&scoped=true"
import script from "./WxCard.vue?vue&type=script&lang=ts"
export * from "./WxCard.vue?vue&type=script&lang=ts"

import "./WxCard.vue?vue&type=style&index=0&id=519f51fa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-519f51fa"

export default script